import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Layout, MapLayout } from "./components/layout/Layout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { MapSearch } from "./pages/MapSearch";
import { Networking } from "./pages/Networking";
import { Packages } from "./pages/Packages";
import { Seasonality } from "./pages/Seasonality";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes with standard layout */}
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/networking" element={<Networking />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/seasonality" element={<Seasonality />} />
          </Route>

          {/* Protected routes with map layout (full height) */}
          <Route element={<MapLayout />}>
            <Route path="/map" element={<MapSearch />} />
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
